<!--
  A view that lays out language selection items
-->
<template>
  <div>
    <div v-show="languages.length">

      <!-- Language items -->
      <ul class="language__items">
        <language-item
          v-for="language in languages"
          v-on:selected="onLanguageSelected"
          :language="language"
          :isActive="language.id === activeId"
          :key="language.id">
        </language-item>
      </ul>
    </div>

  </div>
</template>
<script>
  import api from '@/api/api'
  import languageItem from '@/components/language-item'
  import { loadLanguageAsync } from '@/lang'
  import { Validator } from 'vee-validate'

  export default {
    components: {
      languageItem
    },
    name: 'language-view',
    data: function () {
      return {
        loading: true,
        activeId: null,
        languages: []
      }
    },
    methods: {
      /**
       * Set language and send to next view
       *
       * @param {Object} language - Selected language object
       */
      onLanguageSelected: function (language) {
        // Only run if not already transitioning
        if (this.activeId === null) {
          // Set active language item
          this.activeId = language.id
          // save the language in our global state
          this.$store.commit('setLanguage', language)

          Validator.localize(language.languageIsoCode)

          // Timeout with 0 is used here to allow for a re-render to happen
          // so that the language item active state can update before moving on
          setTimeout(() => {
            this.$router.push('/data-protection')
          }, 0)
          loadLanguageAsync(language.languageIsoCode).then(() => {
            console.log(language.languageIsoCode + ' strings loaded')
          })
        }
      }
    },
    beforeCreate () {
      this.$store.commit('resetState')
    },
    mounted () {
      this.loading = true
      api.getLanguages()
        .then(response => {
          this.loading = false
          this.languages = response.data
        })
        .catch(error => {
          this.loading = false
          console.log(error)
        })
    }
  }
</script>

<style lang="scss">
  @import "../assets/sass/main.scss";

  /*
    We add a top border to all list items then add a bottom border to the last
    child so that we give the impression of a border top and bottom on each item
    without a double line between each item
  */
  .language__items li {
    border-top: $default-border-style;

    @include tablet {
      border: $default-border-style;
      border-bottom: 0;
    }

    &:last-child {
      border-bottom: $default-border-style;
    }
  }
</style>
